import { render, staticRenderFns } from "./MonitorList.vue?vue&type=template&id=81898e90&scoped=true"
import script from "./MonitorList.vue?vue&type=script&lang=js"
export * from "./MonitorList.vue?vue&type=script&lang=js"
import style0 from "./MonitorList.vue?vue&type=style&index=0&id=81898e90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81898e90",
  null
  
)

export default component.exports